import { ControlType, FieldBase } from './field-base';

export class TextareaField extends FieldBase<string> {
  controlType: ControlType = 'textarea';
}
